import Loadable from "react-loadable";

const LazyLivrable = Loadable({
  loader: () => import(/* webpackChunkName: 'livrable' */ "./index"),
  loading: () => 'loading...'
});

export default LazyLivrable;
